import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRecordCircleLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14 7.99933C14 4.68591 11.3134 2 8 2C4.68658 2 2 4.68591 2 7.99933C2 11.3127 4.68658 13.9993 8 13.9993C11.3134 13.9993 14 11.3127 14 7.99933Z",
		stroke: "#16A34A",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.00014 6.19922C8.99401 6.19922 9.80008 7.00527 9.80008 7.99913C9.80008 8.99307 8.99401 9.79907 8.00014 9.79907C7.00621 9.79907 6.2002 8.99307 6.2002 7.99913C6.2002 7.00527 7.00621 6.19922 8.00014 6.19922Z",
		stroke: "#16A34A",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgRecordCircleLine;
